import i18n from "../../i18n"

type Column = {
  id: string
  label: string | null
  path: string
}

export enum MOBILE_TYPE {
  MOBILE = 'mobile',
  BEACON = 'beacon'
}

const COLUMNS = {
  CAR_NAME: {
    id: 'CAR_NAME',
    label: i18n.t('Car name'),
    path: 'mobile_globalid',
    width: '100px'
  },
  DRIVER_NAME: {
    id: 'DRIVER_NAME',
    label: i18n.t('Driver name'),
    path: 'full_name'
  },
  LOCATION: {
    id: 'LOCATION',
    label: i18n.t('Location'),
    path: 'location'
  },
  STOPPED_SPEED: {
    id: 'STOPPED_SPEED',
    label: i18n.t('Stopped/speed'),
    path: 'speed',
    width: '70px'
  },
  LAST_POSITION: {
    id: 'LAST_POSITION',
    label: i18n.t('Last position'),
    path: 'date',
    width: '75px'
  },
  DETAILS: {
    id: 'DETAILS',
    label: null,
    path: 'mobileid',
    disableSort: true,
  }
}

const COLUMNS_BY_VIEW: { [key: string]: Column[] } = {
  VEHICLES: [COLUMNS.CAR_NAME, COLUMNS.LOCATION, COLUMNS.STOPPED_SPEED, COLUMNS.LAST_POSITION, COLUMNS.DETAILS],
  DRIVERS: [COLUMNS.DRIVER_NAME, COLUMNS.LOCATION, COLUMNS.STOPPED_SPEED, COLUMNS.LAST_POSITION]
}

export const getLiveMapViewInfo = (view: string): Column[] => {
  if (COLUMNS_BY_VIEW[view]) {
    const viewColumns = COLUMNS_BY_VIEW[view]
    return viewColumns
  }

  return []
}
